import { useEffect } from 'react';

export function useIdlePrefetch(loaders: Array<() => Promise<any>>) {
  useEffect(() => {
    if (loaders.length === 0) return;

    const task = () => {
      for (const load of loaders) {
        load().catch(() => {});
      }
    };

    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(() => task(), { timeout: 2000 });
    } else {
      setTimeout(task, 1000);
    }
  }, []);
}
